export default function () {
  return [
    {
      title: "Dashboard",
      to: "/dashboard",
      htmlBefore: '<i class="material-icons">view_module</i>',
      htmlAfter: "",
    },
    {
      title: "TV",
      to: "/videos",
      htmlBefore: '<i class="material-icons">people</i>',
      htmlAfter: "",
    },
    {
      title: "TV ADs",
      to: "/ads",
      htmlBefore: '<i class="material-icons">tv</i>',
      htmlAfter: "",
    },
    // {
    //   title: "Users View",
    //   to: "/users",
    //   htmlBefore: '<i class="material-icons">group</i>',
    //   htmlAfter: "",
    // },
    // {
    //   title: "Daily Picks",
    //   to: "/adminsdailypick",
    //   htmlBefore: '<i class="material-icons">list</i>',
    //   htmlAfter: "",
    // },
    // {
    //   title: "Watch list",
    //   to: "/adminswatchlist",
    //   htmlBefore: '<i class="material-icons">list</i>',
    //   htmlAfter: "",
    // },
    // {
    //   title: "Request",
    //   to: "/adminsrequests",
    //   htmlBefore: '<i class="material-icons">book</i>',
    //   htmlAfter: "",
    // },
    // {
    //   title: "Streams",
    //   to: "/admin_streams",
    //   htmlBefore: '<i class="material-icons">chat</i>',
    //   htmlAfter: "",
    // },
    // {
    //   title: "Users Stream",
    //   to: "/users_stream",
    //   htmlBefore: '<i class="material-icons">chat</i>',
    //   htmlAfter: "",
    // },
    // {
    //   title: "Blog Dashboard",
    //   to: "/blog-overview",
    //   htmlBefore: '<i class="material-icons">edit</i>',
    //   htmlAfter: "",
    // },
    // {
    //   title: "Blog Posts",
    //   htmlBefore: '<i class="material-icons">vertical_split</i>',
    //   to: "/blog-posts",
    // },
    // {
    //   title: "Add New Post",
    //   htmlBefore: '<i class="material-icons">note_add</i>',
    //   to: "/add-new-post",
    // },
    // {
    //   title: "Forms & Components",
    //   htmlBefore: '<i class="material-icons">view_module</i>',
    //   to: "/components-overview",
    // },
    // {
    //   title: "Tables",
    //   htmlBefore: '<i class="material-icons">table_chart</i>',
    //   to: "/tables",
    // },
    // {
    //   title: "User Profile",
    //   htmlBefore: '<i class="material-icons">person</i>',
    //   to: "/user-profile-lite",
    // },
    // {
    //   title: "Errors",
    //   htmlBefore: '<i class="material-icons">error</i>',
    //   to: "/errors",
    // },
  ];
}
